import React from 'react';
const About = () => <div>This is about page</div>;
export default About;